<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO DO ESTOQUE</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="SEPARAÇÃO/CHECAGEM DE MEDICAMENTOS">
            <div class="row">
              <div class="col-md-4">
                <label for="allow_stock_unique">ATIVAR CONFIGURAÇÃO</label>
                <select v-model="allow_stock_unique" class="form-control">
                  <option value="NAO">NÃO</option>
                  <option value="SIM">SIM</option>
                </select>
              </div>
              <div v-if="allow_stock_unique == 'SIM'" class="col-md-8">
                <label for="allow_stock_unique"
                  >ESTOQUE QUE IRÁ APARECER NA SEPARAÇÃO/CHECAGEM DE
                  MEDICAMENTOS</label
                >
                <select v-model="stock_unique_id" class="form-control">
                  <option :value="null">SELECIONE...</option>
                  <option
                    v-for="(stock, key) in stocks"
                    :key="key"
                    :value="stock.id"
                  >
                    {{ stock.name }}
                  </option>
                </select>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "StockConfig",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],

      stocks: [],

      allow_stock_unique: "NAO",
      stock_unique_id: null,

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.getStocks();
      await this.get();
    },

    // Migrado para o estoque novo
    async getStocks() {
      this.loading = true;

      const response = await api.get("/rest-home/stock/groups");

      const { error, errors, stock_groups } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        this.stocks = stock_groups;
      }
    },

    async get() {
      this.loading = true;

      const response = await api.get("/rest-home/settings/stock-unique");

      const { error, errors, allow_stock_unique, stock_unique_id } =
        response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        this.allow_stock_unique = allow_stock_unique == 1 ? "SIM" : "NAO";
        this.stock_unique_id = stock_unique_id;
      }
    },

    async save() {
      try {
        this.loading = true;

        let { allow_stock_unique, stock_unique_id } = this;

        const data = { allow_stock_unique, stock_unique_id };

        const response = await api.patch(
          "/rest-home/settings/stock-unique",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
